import MyAdmin from "./admin";

const App = () => <MyAdmin />;

export default App;
